<p-dialog modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <span class="atlas-dialog-header">{{ 'revenue.transactions-grid.unapplied-payments.adjust.header' | translate |
      titlecase }}</span>
  </ng-template>
  <form #crudForm="ngForm" class="atlas-form">
    <div class="mb-27 mct-flex mct-row mct-wrap mct-justify-start mct-items-center mct-gap-27">
      <div>
        <label class="light-text">{{ 'common.date' | translate | ucfirst }}</label>
        <span class="f-wb">{{ unappliedPayment.ApplyDate | date : 'MM/dd/yyyy' }}</span>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.transactions-grid.unapplied-payments.transaction-type' | translate |
          ucfirst }}</label>
        <div *ngIf="unappliedPayment.AppliedToPaymentId > 0" class="ws-p f-wb">
          {{ 'revenue.transactions-grid.unapplied-payments.applied-to-invoice' | translate | titlecase }} #{{
          unappliedPayment.InvoiceNumber
          }}
        </div>
        <div *ngIf="unappliedPayment.AppliedToPaymentId === 0" class="f-wb">
          {{ unappliedPayment.PaymentType1?.Descr }}
        </div>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.transactions-grid.unapplied-payments.amount' | translate | ucfirst
          }}</label>
        <span class="f-wb">{{ unappliedPayment.AdjustedAmount | currency }}</span>
      </div>
    </div>
    <div class="mct-flex mct-col mct-gap-27">
      <div>
        <label class="light-text">{{ 'revenue.transactions-grid.unapplied-payments.adjust.adjustment-date' | translate |
          ucfirst }}</label>
        <wl-date-selector ngDefaultControl [required]="true" appendTo="body" name="adjustmentDate"
          [(ngModel)]="adjustment.AdjustmentDate"></wl-date-selector>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.transactions-grid.unapplied-payments.adjust.apply-date' | translate |
          ucfirst }}</label>
        <wl-date-selector ngDefaultControl [required]="true" appendTo="body" name="applyDate"
          [(ngModel)]="adjustment.ApplyDate"></wl-date-selector>
      </div>
      <div class="w-100">
        <label class="light-text">{{ 'revenue.transactions-grid.unapplied-payments.adjust.adjustment-type' | translate |
          ucfirst }}</label>
        <p-select required appendTo="body" name="adjustmentType" [(ngModel)]="adjustment.AdjustmentTypeId"
          [options]="adjustmentTypeItems" [placeholder]="'common.select-dashes' | translate | ucfirst"></p-select>
      </div>
      <div class="w-100">
        <label class="light-text">{{ 'common.description' | translate | ucfirst }}</label>
        <textarea pInputTextarea name="descr" class="w-100" [(ngModel)]="adjustment.Descr"
          [autoResize]="true"></textarea>
      </div>
      <div>
        <label class="light-text">{{
          'revenue.transactions-grid.unapplied-payments.adjust.adjustment-amount' | translate | ucfirst
          }}</label>
        <div class="p-inputgroup">
          <button type="button" class="atlas-input-addon" (click)="flipAdjustmentSign()">{{ adjustmentSign }}</button>
          <span class="atlas-input-addon">$</span>
          <input pInputText name="amount" [(ngModel)]="adjustment.AdjustmentAmount" type="number"
            [disabled]="adjustment.Posted" (input)="formatAdjustmentAmount()" />
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!crudForm.valid" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>

<p-confirmDialog #refundCD key="refundCreditCardAdjustmentCD"
  header="{{ 'revenue.transactions-grid.unapplied-payments.credit-refund-header' | translate | ucfirst }}"
  icon="pi pi-question">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="refundCD.accept()">
      {{ 'revenue.transactions-grid.unapplied-payments.refund-charge' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="createSimpleAdjustment()">
      {{ 'revenue.transactions-grid.unapplied-payments.adjust-without-refunding' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="refundCD.reject()">{{
      'common.cancel' | translate | uppercase }}</button>
  </ng-template>
</p-confirmDialog>